import React from "react";
import logoSvg from "../assets/images/logo-svg.svg";
import { setAdditionalClasses } from "../assets/js/utils";
import useAnimationAppear from "./hooks/useAnimationAppear";
// import logo from "../assets/images/logo.png";
// import logo2X from "../assets/images/logo@2x.png";

function Logo({
  applyAnimationVanishClassName,
  applyAnimationMenuAppearClassName,
  onPress,
}) {
  const applyAnimationAppear = useAnimationAppear();
  return (
    <img
      src={logoSvg}
      alt="logo"
      className={`logo animate-logo-appear${setAdditionalClasses(
        ["animate-logo-appear", "animate-logo-vanish"],
        [
          applyAnimationMenuAppearClassName || applyAnimationAppear,
          applyAnimationVanishClassName,
        ]
      )}`}
      // srcSet={`${logo} 1x, ${logo2X} 2x`}
      onClick={onPress}
    />
  );
}

export default Logo;
